import { render } from "./FilterItemAddHeader.vue?vue&type=template&id=8c54cb60"
import script from "./FilterItemAddHeader.vue?vue&type=script&lang=js"
export * from "./FilterItemAddHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__